import { render, staticRenderFns } from "./UserNameColumn.vue?vue&type=template&id=1bb6c51f&"
import script from "./UserNameColumn.vue?vue&type=script&lang=js&"
export * from "./UserNameColumn.vue?vue&type=script&lang=js&"
import style0 from "./UserNameColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb6c51f')) {
      api.createRecord('1bb6c51f', component.options)
    } else {
      api.reload('1bb6c51f', component.options)
    }
    module.hot.accept("./UserNameColumn.vue?vue&type=template&id=1bb6c51f&", function () {
      api.rerender('1bb6c51f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/UserNameColumn.vue"
export default component.exports